import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">91免费视频</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed mb-4">
              海量高清视频资源，无需注册即可免费在线观看。涵盖多种类型视频内容，随时随地享受优质免费视频体验。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/entertainment" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">视频分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/entertainment" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">娱乐综艺</Link></li>
              <li><Link to="/category/education" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">教育学习</Link></li>
              <li><Link to="/category/technology" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">科技数码</Link></li>
              <li><Link to="/category/lifestyle" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">生活美食</Link></li>
              <li><Link to="/category/sports" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">体育竞技</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line text-base"></i>
                <span>contact@91freevideo.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区科技园路88号</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-50/40">© 2024 91免费视频 版权所有</p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}